import classNames from 'classnames';
import * as React from 'react';

import { NavbarButton } from './navbar-button';

type Props = {
  open: boolean;
  selectPage: (page: number) => void;
};

export class Navbar extends React.PureComponent<Props> {
  public render() {
    const { open, selectPage } = this.props;

    return (
      <nav className={classNames('navbar', { 'navbar--open': open })}>
        <NavbarButton to="/" onClick={() => { selectPage(0); }}>Home</NavbarButton>
        <NavbarButton to="/menu" onClick={() => { selectPage(1); }}>Menu</NavbarButton>
        <NavbarButton to="/catering" onClick={() => { selectPage(2); }}>Catering</NavbarButton>
        <NavbarButton to="/about" onClick={() => { selectPage(3); }}>Over ons</NavbarButton>
      </nav>
    );
  }
}
